import React from "react";
import {
  View,
  Text,
  Platform,
  StyleSheet,
  TouchableOpacity,
} from "react-native";

import AppConfig from "../../../../../config/AppConfig";
import { downloadOrEmailURL } from "../../../../../helpers/utils";
import AppTheme from "../../../AppTheme";
import IntegrationIcons from "../../../common/icons/integrations";
import IntegrationsHelper, { INTEGRATION_KEYS } from "../../IntegrationsHelper";

export default function DownloadButtons({ controller, onDownload = () => {} }) {
  const download = (env) => {
    onDownload();
    IntegrationsHelper.saveIntegrations(
      controller,
      {
        [INTEGRATION_KEYS.desktop]: true,
        [`autotrack_${INTEGRATION_KEYS.desktop}`]: true,
      },
      () => {
        downloadOrEmailURL(controller, env, AppConfig[`${env}_DOWNLOAD_URL`]);
      },
    );
  };

  return (
    <View style={styles.buttons}>
      <TouchableOpacity onPress={() => download("MAC")} style={styles.button}>
        <IntegrationIcons.MacIcon width={14} height={14} style={styles.icon} />

        <Text style={styles.buttonText}>Get Mana for Mac</Text>
      </TouchableOpacity>

      <TouchableOpacity onPress={() => download("WIN")} style={styles.button}>
        <IntegrationIcons.WindowsIcon
          width={14}
          height={14}
          style={styles.icon}
        />
        <Text style={styles.buttonText}>Get Mana for PC</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  buttons: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 30,
  },
  button: {
    width: 284,
    height: 31,
    backgroundColor: "#F3F2F1",
    shadowOpacity: 0.1,
    shadowOffset: { width: 0, height: 4 },
    shadowColor: "#000",
    shadowRadius: 3,
    elevation: 5,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginBottom: 8,
  },
  icon: {
    width: 14,
    height: 14,
    marginRight: 6,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
